
  
const initState = {
    backOrder: [],
    page: 1,
    limit: 10,
    count: 0
  };
  
  const BackOrderReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_BACKORDER':
        return {
          ...state,
          backOrder: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_BACKORDER_STATE':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default BackOrderReducer;
  